import { Box, Flex, Heading, Skeleton, Text } from '@chakra-ui/react';

import { DiscountTag } from './discount-tag';
import { ExperimentPlan } from './plan-helpers';

export function PriceRow({
  isSelected,
  plan,
  onSelect,
}: {
  isSelected: boolean;
  plan: ExperimentPlan;
  onSelect: () => void;
}) {
  return (
    <Box
      aria-pressed={isSelected}
      as='button'
      bg={isSelected ? '#F4F8FF' : '#F9F9F9'}
      border='1px solid'
      borderColor={isSelected ? '#175CFF' : '#F2F2F2'}
      borderRadius='8px'
      minHeight={plan.value === 'monthly' ? '60px' : '84px'}
      overflow='hidden'
      textAlign='left'
      type='button'
      width='100%'
      onClick={onSelect}
    >
      {plan.savingsBlurb && (
        <Text
          bg='#175CFF'
          color='white'
          fontSize='10px'
          fontWeight='600'
          lineHeight='16px'
          paddingY='4px'
          textAlign='center'
        >
          {`${plan.savingsBlurb} vs paying monthly`}
        </Text>
      )}
      <Flex
        alignItems='center'
        gap={3}
        justifyContent='space-between'
        minHeight={plan.savingsBlurb ? '60px' : plan.value === 'monthly' ? '58px' : '82px'}
        paddingX={3}
        paddingY={2}
      >
        <Flex alignItems='center' gap={3}>
          <Flex
            alignItems='center'
            border='1.2px solid'
            borderColor={isSelected ? '#175CFF' : '#9C9FA8'}
            borderRadius='full'
            flex='0 0 18px'
            height='18px'
            justifyContent='center'
            width='18px'
          >
            {isSelected && <Box bg='#175CFF' borderRadius='full' height='8px' width='8px' />}
          </Flex>
          <Box>
            <Text color={isSelected ? '#0B0B0B' : '#555555'} fontSize='16px' fontWeight='500' lineHeight='18px'>
              {plan.label}
              {plan.value !== 'monthly' && <Box as='sup'>1</Box>}
            </Text>
            {plan.displayPrice && (
              <Text color='#5A5C62' fontSize='11px' fontWeight='400' lineHeight='16px'>
                {plan.value === 'monthly'
                  ? 'Billed monthly'
                  : `Single payment${plan.fullDisplayPrice ? ` of ${plan.fullDisplayPrice}` : ''}`}
              </Text>
            )}
          </Box>
        </Flex>
        {plan.displayPrice ? (
          <Box textAlign='right'>
            {plan.strikeThroughDisplayPrice && (
              <Flex alignItems='center' gap={1} justifyContent='flex-end'>
                <Text as='del' color='supportGray.60' fontSize='12px' fontWeight='600'>
                  {plan.strikeThroughDisplayPrice}
                </Text>
                {plan.couponApplied && typeof plan.couponPercentOff === 'number' && (
                  <DiscountTag value={plan.couponPercentOff} />
                )}
              </Flex>
            )}
            <Flex alignItems='baseline' flexWrap='wrap' gap={1}>
              <Heading
                as='span'
                fontFamily='body'
                fontSize='26px'
                fontWeight='600'
                lineHeight='28px'
                whiteSpace='nowrap'
              >
                {plan.displayPrice}
              </Heading>
              <Text color='#5D5D5D' fontSize='13px' fontWeight='400' lineHeight='18px' whiteSpace='nowrap'>
                {plan.displayPriceUnits}
              </Text>
            </Flex>
          </Box>
        ) : (
          <Skeleton height='28px' width='92px' />
        )}
      </Flex>
    </Box>
  );
}
